import { useFeatureFlagsRuntime } from './FeatureFlagsRuntimeProvider'

export const useFeatureFlag = (flagName, options = {}) => {
  const { getFlagValue } = useFeatureFlagsRuntime()
  return getFlagValue(flagName, options)
}

export const useFlag = (flagName, options = {}) =>
  useFeatureFlag(flagName, options)
